import pairs from "./video-blog-hreflang-pairs.json";

const SITE = "https://www.tu.biz";

/** Static EN ↔ ES page pairs (exact paths). */
export const STATIC_HREFLANG_PAIRS = [
	{ en: "/en", es: "/es" },
	{ en: "/en/video-blogs", es: "/es/video-blog" },
	{ en: "/en/fluid-power-formulas", es: "/es/formulas-hidraulicas" },
	{ en: "/en/contact-us", es: "/es/contactenos" },
	{ en: "/en/products", es: "/es/productos" },
	{
		en: "/en/products/hydraulics/industrial-valves/modular-valves",
		es: "/es/productos/hidraulicos/valvulas/industriales/valvulas_modulares/valvulas_stack",
	},
	{
		en: "/en/products/hydraulics/industrial-valves/pressure-control-valves",
		es: "/es/productos/hidraulicos/valvulas/industriales/control_de_presion/valvulas_control_de_presion",
	},
	{
		en: "/en/products/hydraulics/pumps/piston_pumps/c11_h20_h80",
		es: "/es/productos/hidraulicos/bombas/bombas_de_pistones/c11_h20_h80",
	},
	{
		en: "/en/products/hydraulics/motors/piston-motors",
		es: "/es/productos/hidraulicos/motores/motores_de_pistones",
	},
	{ en: "/en/inventory", es: "/es/inventario" },
	{ en: "/privacy-policy", es: "/privacy-policy" },
	{ en: "/terms-and-conditions", es: "/terms-and-conditions" },
];

/** @type {Map<string, string>} */
const enToEs = new Map(Object.entries(pairs));
/** @type {Map<string, string>} */
const esToEn = new Map(
	Object.entries(pairs).map(([en, es]) => [es, en]),
);

function abs(path) {
	return `${SITE}${path}`;
}

/**
 * @param {string} path
 * @returns {{ hreflang: string, href: string }[] | null}
 */
export function getHreflangAlternates(path) {
	const clean = path.split("#")[0].split("?")[0] || "/";

	for (const { en, es } of STATIC_HREFLANG_PAIRS) {
		if (clean === en || clean === es) {
			const xDefault = en === "/en" && es === "/es" ? es : en;
			return [
				{ hreflang: "en", href: abs(en) },
				{ hreflang: "es", href: abs(es) },
				{ hreflang: "x-default", href: abs(xDefault) },
			];
		}
	}

	if (clean.startsWith("/en/video-blogs/")) {
		const esPath = enToEs.get(clean);
		if (esPath) {
			return [
				{ hreflang: "en", href: abs(clean) },
				{ hreflang: "es", href: abs(esPath) },
				{ hreflang: "x-default", href: abs(clean) },
			];
		}
		return [
			{ hreflang: "en", href: abs(clean) },
			{ hreflang: "x-default", href: abs(clean) },
		];
	}

	if (clean.startsWith("/es/video-blog/")) {
		const enPath = esToEn.get(clean);
		if (enPath) {
			return [
				{ hreflang: "en", href: abs(enPath) },
				{ hreflang: "es", href: abs(clean) },
				{ hreflang: "x-default", href: abs(enPath) },
			];
		}
		return [
			{ hreflang: "es", href: abs(clean) },
			{ hreflang: "x-default", href: abs("/en/video-blogs") },
		];
	}

	if (clean.startsWith("/en/")) {
		return [
			{ hreflang: "en", href: abs(clean) },
			{ hreflang: "x-default", href: abs(clean) },
		];
	}

	if (clean.startsWith("/es/")) {
		return [
			{ hreflang: "es", href: abs(clean) },
			{ hreflang: "x-default", href: abs("/en") },
		];
	}

	return null;
}
